<div class="flex" [ngClass]="{'sidebar-active': app.sidebarActive}">
    <div class="sidebar-next-right-block">
        <div class="partner-right-block-body">
            <partner-appconfig-store-branding *ngIf="activePartnerAppConfigMenu === partnerAppConfigMenuEnum.Branding"></partner-appconfig-store-branding>
            <partner-appconfig-recommended-products *ngIf="activePartnerAppConfigMenu === partnerAppConfigMenuEnum.Products"></partner-appconfig-recommended-products>
            <partner-appconfig-categories *ngIf="activePartnerAppConfigMenu === partnerAppConfigMenuEnum.Categories"></partner-appconfig-categories>
        </div>
    </div>
</div>
